/******************************************************************************************

     _                      _
    (_) _ __   ____  _ _   (_) _ __  __ _
    | |( '_ '\/ ,__)( '_'\ | |( '__)/'_' )
    | || | ) )\__, \| (_) )| || |  ( (_| |
    (_)(_) (_)(____/|  __/ (_)(_)   \__,_)
                    | |
                    (_)

    Inspira Digital Alterations - General Script
    =============================================
    

******************************************************************************************/

console.log('%cinspira digital', 'font-size:28px;font-weight:bold;color:#009ee2;text-shadow:0 1px 0 #ccc,0 2px 0 #c9c9c9,0 3px 0 #bbb,0 4px 0 #b9b9b9,0 5px 0 #aaa,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 10px 10px rgba(0,0,0,.15);');
console.log('%cmaking sense of the web since 2008','font-size:12.3px;color:#aaa;padding-left: 1.9px;');



// Inspira util //

/*
  @info: Should only contain functions that need to be used for mutli-unrelated functions.
  @note: None of these classes relate to each other - treat like utill file.
*/

if(typeof inspira === 'undefined'){
  var inspira = {};
}

inspira.extend = function(target,parent){
  for (prop in parent){
    if(!target.hasOwnProperty(prop)){
      target[prop] = parent[prop];
    }
  }
  return target;
}

inspira.findInUrl = function(param){
	const url = new URL(window.location.href);
	const value = url.searchParams.get(param);
	return value;
}

inspira.params = function(){
    var params = {};
    var param_array = window.location.href.split('?');
    if(param_array.length > 1){
      param_array = param_array[1].split('&');
    }else{
      console.log('No param set in url, user didn\'t get here normally')
      return false;
    }
    for(var i in param_array){
        x = param_array[i].split('=');
        params[x[0]] = x[1];
    }
    return params;
}();

inspira.lazyLoad = function(){
  $('.frame-element .image').each(function(){
    if($(this).data('bksrc') === undefined){return false;}
    $(this).css('background-image','url(' + $(this).data('bksrc') + ')');
    if($(this).data('bksrchover') !== undefined){
      $(this).hover(inspira.hoverImage,inspira.hoverImage)
    }

    $(this).click(function(){
      var $self = $(this);
      $('.frame-element .image').each(function(){
        if($self == $(this)){return true}
        if($(this).data('bksrc') === undefined){return false;}
        $(this).css('background-image','url(' + $(this).data('bksrc') + ')'); 
      })
    })
  })
  $('.feature-image img').each(function(){
    if($(this).data('src') === undefined){return false;}
    $(this).attr('src', $(this).data('src'))
  })
}

inspira.hoverImage = function(){
  const $elm = $(this); 
  const newImage = $elm.data('bksrchover');
  console.log($elm.data('bksrchover'),$elm.data('bksrc'))
  $elm.data('bksrchover',$elm.data('bksrc'));
  $elm.data('bksrc',newImage);
  
  if(!$elm.hasClass('frame-selected')){
    $elm.css("background-image",'url(' + newImage  + ')')
  }
}

inspira.scrollTop = function(){
    $('html, body').animate({
        scrollTop: $("#content").offset().top - 200
    }, 500);
}

inspira.getStep = function(){
  return $('.step:not(.hide)').index();
}

inspira.switchStep = function(num){
    $('.step').addClass('hideStep');
    $('.step').eq(num).removeClass('hideStep')

    // old code if($('.frame-nav .active').index() == $('.frame-nav li').index()){
    if(num == 6){
      $('.total-submit .next').addClass('hide');
      $('.total-submit .add').addClass('show-inline');
      $('.frames-bespoke .header-frame:not(.top)').addClass('hide');
    }else{
      $('.total-submit .next').removeClass('hide')
      $('.frames-bespoke .header-frame:not(.top)').removeClass('hide');
      $('.total-submit .add').removeClass('show-inline')
    }
}

inspira.closeFramesPopup = function(){
  $('.frames-popup-background').hide();
  $('.frames-popup').hide();
  $('html').removeClass('stop-scroll');
  $('body').removeClass('stop-scroll');
}

inspira.preloadImage = function(url){
  var img=new Image();
  img.src=url;
}

inspira.popupImageSlide = function(){
  var slideImages = $('.frames-popup .portfolio img');
  slideImages.each(function(){
    inspira.preloadImage($(this));
  })
  var getImage = function(num,dir){
    var slideNum = 1;
    if(dir == '-'){slideNum = num - 1;}
    if(dir == '+'){slideNum = num + 1;}
    if(num <= 0 && dir == '-') slideNum = slideImages.length -1;
    if(num >= slideImages.length -1 && dir == '+') slideNum = 0;
    return slideImages.eq(slideNum);
  };

  slideImages.click(function(){
    changeImage($(this));
  })

  var changeImage = function($img){
    slideImages.removeClass('current');
    $img.addClass('current');
    $('.frames-popup .feature-image img').attr("src", $img.data("src"));
  }

  $('.frames-popup .left .back').click(function(){
    var img = getImage($('.frames-popup .portfolio img.current').index(),'-')
    changeImage(img)
  })

  $('.frames-popup .next').click(function(){
    var img = getImage($('.frames-popup .portfolio img.current').index(),'+')
    changeImage(img)
  })
}

inspira.preload = function(img){
  Shopify.Image.preload(img);
}

// CustomiserUI Functions //

const bindChangeNav  = (function(){
  return {
    changeNav: function(){


      let mobileElm = $('.mobile-header');
      let parentElm = $('.frames-customiser .frame-nav');
      var numClicked = 1;
      var currentNum;

      parentElm.find('li').click(function(){
        if($(this).hasClass('active')) return false;
        numClicked = $(this).index(); // 0 index number of li element clicked
        currentNum = '';

        // If this is clicked, take the user back to the your details page //
        if((numClicked) == 0){
          window.location = '/pages/your-details';
          return false;
        }

        // Find the current Index via finding the first value not finished //
        parentElm.find('li').each(function(index){
          if($(this).hasClass('finished')) return true;
          currentNum = index; return false;
        })

        // If the current section is not the last in the list on change, check its valid //
        parentElm.find('li').each(function(index){
          if(index > currentNum && $(this).hasClass('finished')){
            const currentSection = $('.step:not(.hideStep)').attr('name');
            let errors = getSectionErrors(getSection(currentSection));
            if(errors) {customiserUI.showErrors(errors); return false};
          }
        })

        // If the user is trying to click a value which is further on than the current and is not already set to finished, stop them //
        if(numClicked > currentNum && !parentElm.find('li').eq(numClicked).hasClass('finished')) return false;

        // Remove all "active" classes //
        parentElm.find('li').removeClass('active');
        // Take the current option and set it to finished
        if(parentElm.find('li').eq(currentNum+1).hasClass('finished')){
          parentElm.find('li').eq(currentNum).addClass('finished');
        }
        // For the new section, remove finished if it has it and set it to active //
        $(this).addClass('active').removeClass('finished');
        // Repeat for mobile //
        mobileElm.find('li').removeClass('active');
        mobileElm.find('li').eq(numClicked).addClass('active')
        inspira.switchStep(numClicked - 1);
      })


      mobileElm.find('.back').click(function(){
        var index = $('.mobile-header li.active').index();
        if(index === 1) return false;
        $('.mobile-header li').removeClass('active')
        $('.mobile-header li').eq(index + 1).addClass('active');
        const nextStep = $('.step').eq(($('.step:not(.hideStep)').parent().index() - 1));
        $('.frames-bespoke .header-frame').removeClass('hide');
        customiserUI.changeStep(nextStep.attr('name'))
      })
    }
  }
}())

const bindChangeStep  = (function(){
  return {
    changeStep: function(name){
      let stepNumber = $('.step[name="' + name + '"]').parent().index();
      let navNumber = stepNumber + 1;

      $('.mobile-header li').removeClass('active');
      $('.mobile-header li').eq(navNumber)
      .addClass('active');
      $('.frames-customiser .frame-nav li:nth-child(-n + ' + (navNumber) +')')
      .addClass('finished')
      .removeClass('active');
      $('.frames-customiser .frame-nav li').eq(navNumber)
      .addClass('active').removeClass('finished');;

      inspira.switchStep(stepNumber);
    }
  }
}())

const bindSwitchSelectedFrame  = (function(){
  return {
    switchSelectedFrame: function(){
    $('.frame-element').click(function(){
      $(this)
      .parent('.grid')
      .find('.frame-element')
      .removeClass('selected');
      $(this)
      .parent('.grid')
      .find('.frame-element .image')
      .removeClass('frame-selected');
      $(this)
      .addClass('selected');
      $(this)
      .find('.image')
      .addClass('frame-selected selected');
    })

    $('.orientation').click(function(){
      $(this)
      .parent('.grid')
      .find('.orientation')
      .removeClass('selected')
      .removeClass('orientation-selected');
      $(this)
      .addClass('selected orientation-selected');
    })

    $('.shape').click(function(){
      $(this)
      .parent('.grid')
      .find('.shape')
      .removeClass('selected')
      .removeClass('shape-selected');
      $(this)
      .addClass('selected shape-selected');
    })
    }
  }
}())

const bindStyledSelects  = (function(){
  return {
    styledSelect: function(){
      $('.select-styled').click(function(e){
        e.stopPropagation()
        $(this).addClass('clicked')
      })
      $('body').click(function(){
        $('.select-styled').removeClass('clicked')
      })
      $('.select-styled li').click(function(event){
         event.stopPropagation();
        $(this)
        .parents('.select-styled').eq(0)
        .addClass('select')
        .data('value',$(this).html().toLowerCase())
        .find('.value').html($(this).html())
        $('.select-styled').removeClass('clicked');
      })

      $('.input-range').on('input', function() {
        $(this).next('.range-value').html(this.value + 'mm');
        $(this)
        .parents('.select-styled').eq(0)
        .data('value',this.value)
      });
    }
  }
}())

const bindInputData = (function(){
  return {
    setInputData: function(){
      $('.input-styled input').change(function(){
        $('.input-styled input').each(function(){
          $(this).val().length > 0 ? $(this).addClass('has-content') : $(this).removeClass('has-content');
        });
        $(this)
        .parents('.input-styled').eq(0)
        .data('value', $(this).val().toLowerCase())
      })
    }
  }
}())

const bindGetInput = (function() {
  return {
    getInput : function($id,dataName){
      dataName = typeof dataName !== 'undefined' ? dataName : 'value';
      if(!$id.length) return false;
      if(!$id.data(dataName)) return false;
      return $id.data(dataName);
    }
  }
}())

const bindShowMore  = (function(){
  return {
    showMore: function(){
      $('.more').click(function(){
          $('#current-popup').html(
            $(this)
            .parents('.frame-element').eq(0)
            .find('.popup-content').html()
            );

          inspira.popupImageSlide();

          $('html').addClass('stop-scroll');
          $('body').addClass('stop-scroll');

          $('.frames-popup-background').show();
          $('.frames-popup').show();

          $('.frames-popup-background, .frames-popup .close, .button.back, .button.select').click(function(){
              inspira.closeFramesPopup();
          })
      })

    }
  }
}())

const preloadImages  = (function(){
  return {
    preload: function(img){
     inspira.preload(img);
    }
  }
}())

const errors = (function(){
  return {
    showErrors: function(err, expMessage) {
      let type = 1;
      let message = [
        'Please Provide',
        'Please Select',
        '',
        'To Proceed To The Next Step'
      ];
      let exceptions = [
        'height',
        'width',
        'unit',
        'columns',
        'rows'
      ]
      $('.error').removeClass('error');
      message[2] = [err.slice(0, -1).join(', '), err.slice(-1)[0]].join(err.length < 2 ? '' : ' and ');
      err.forEach(function(item) {
        if(exceptions.toString().indexOf(item) !== -1){type = 0;}
      })
      if(type===0){
        err.forEach(function(item){
          $('#' + item).addClass('error');
        })
      }
      if(err.length === 1){message[2] = 'a ' +  message[2]}
      err = message[type] + ' ' + message[2] + ' ' + message[3];
      if(expMessage){err = expMessage}
      $('.error-area').removeClass('remove').find('.title').html(err);
      setTimeout(function() {
        $('.error-area').addClass('remove')
      }, 6000)
    }
  }
}())

const cart = (function(){
  var add,show,hide;

  get = function(){
    return $.ajax( "https://rougholdglass.appira.com/createProduct?id=4198937&email=" + inspira.params.email);
  }

  add = function(data){
    var cartPopupTemplate = [
        '<div id="cart-summary-overlay" class="cf">',
            '<div class="item">',
                '<div class="just-title">'+"Just added:"+'</div>',
                '<div class="cols">',
                    '<div class="img"><img src="[[image_url]]" /></div>',
                    '<div class="info">',
                        '<div>[[title]]</div>',
                        '<div>[[price]]</div>',
                    '</div>',
                    '<div class="detail">',
                        '<div>'+"Qty"+' [[quantity]]</div>',
                        '<div>'+"Total"+' [[line_price]]</div>',
                    '</div>',
                '</div>',
            '</div>',
            '<div class="cart">',
                '<div>',
                    "Subtotal"+' <span>[[subtotal]]</span>',
                '</div>',
                '<div class="cart-text">'+"Excl. shipping"+'&nbsp;</div>',
                '<div>',
                    '<a id="shop-more" class="button altcolour" href="#">'+"Keep Shopping"+'</a>',
                    '<a class="button to-cart" href="/cart">'+"Cart"+'</a>',
                '</div>',
            '</div>',
        '</div>'
        ].join('');

        var shopifyAjaxAddURL = '/cart/add.js';
        var shopifyAjaxCartURL = '/cart.js';
        var shopifyAjaxStorePageURL = '/search';
        //Add to cart
        $.post(shopifyAjaxAddURL,data, function(itemData) {


            //Get our data
            var addedDataJSON = $.parseJSON(itemData);


            //Get current cart state
            $.get(shopifyAjaxCartURL, function(cartData){
              var cartDataJSON = $.parseJSON(cartData);
              
              var addedQty = $('#quantity .value').html();
              var addedImage = addedDataJSON.image;

              //Now we have all the data, build the shade
              var cartShadeHTML = cartPopupTemplate;
              cartShadeHTML = cartShadeHTML.replace('[[title]]', addedDataJSON.title);
              cartShadeHTML = cartShadeHTML.replace('[[quantity]]', addedQty);
              cartShadeHTML = cartShadeHTML.replace('[[image_url]]', addedImage);
              cartShadeHTML = cartShadeHTML.replace('[[price]]', Shopify.formatMoney(addedDataJSON.price)).replace('$', '£');
              cartShadeHTML = cartShadeHTML.replace('[[line_price]]', Shopify.formatMoney(addedDataJSON.price * addedQty)).replace('$', '£');;
              cartShadeHTML = cartShadeHTML.replace('[[subtotal]]', Shopify.formatMoney(cartDataJSON.total_price)).replace('$', '£');;

              var $cartShade = $(cartShadeHTML);
              $cartShade.find('#shop-more').bind('click', function(){
                $cartShade.animate({top: - $cartShade.outerHeight()}, 500, function(){ $(this).remove(); });
                return false;
              });
              $cartShade.prependTo('body').css('top', - $cartShade.outerHeight()).animate({top: 0}, 500);

            }, 'html');

            //Update header summaries
            $.get(shopifyAjaxStorePageURL, function(data){
              var cartSummarySelectors = ['#pageheader .cart-summary .cart-count', '#mobile-header .cart-count'];
              for(var i=0; i<cartSummarySelectors.length; i++) {
                var $newCartObj = $('<div>' + data + '</div>').find(cartSummarySelectors[i]).first();
                var $currCart = $(cartSummarySelectors[i]);
                $currCart.html($newCartObj.html());
              }
            });
        }, 'text')

  }
  hide = function(){
    $('.add-to-cart-header').addClass('hide');
  }
  show = function(){
    $('.add-to-cart-header').removeClass('hide');
  }

  return {
    bindCartEvents: function(){
      $('#add-customise, .total-submit .add').click(function(){
        //show();
        get().then(function(data){
          console.log(data)
          add(data);
        });
      })

      $('.frames-customiser').not('div#add-customise').click(function(event){
        if($(event.target).text() === "Add To Cart") return false;
        hide();
      })
    },
  }
}())


// END customiserUI Functions //


const customiserUI = (function(){
  return $.extend(
    {},
    bindChangeNav,
    bindChangeStep,
    bindSwitchSelectedFrame,
    bindShowMore,
    bindStyledSelects,
    bindInputData,
    bindGetInput,
    preloadImages,
    errors,
    cart
  );
}())

$(function(){
    const ui = customiserUI;
    ui.changeNav();
    ui.switchSelectedFrame();
    ui.showMore();
    ui.styledSelect();
    ui.setInputData();
    ui.bindCartEvents();
    ui.preload([
    '//rougholdglass.co.uk/cdn/shop/t/72/assets/step-finished.png?v=81510529693752226181792091782',
    '//rougholdglass.co.uk/cdn/shop/t/72/assets/step-finished-hover.png?v=167402484809080441261792091782',
    '//rougholdglass.co.uk/cdn/shop/t/72/assets/frame-tick.png?v=121125616530697972561792091782',
    '//rougholdglass.co.uk/cdn/shop/t/72/assets/framesprites.png?v=31183331849492251861792091782',
    '//rougholdglass.co.uk/cdn/shop/t/72/assets/error-alert.png?v=45930855507944704011792091782',
    '//rougholdglass.co.uk/cdn/shop/t/72/assets/mirror-select.png?v=137067925529338420671792091782',
    '//rougholdglass.co.uk/cdn/shop/t/72/assets/frame-select.png?v=48781212041820540401792091782',
    '//rougholdglass.co.uk/cdn/shop/t/72/assets/frame-no-image-select.png?v=93448943584993825631792091782',
    '//rougholdglass.co.uk/cdn/shop/t/72/assets/more-info.png?v=47039734496450617311792091782',
    '//rougholdglass.co.uk/cdn/shop/t/72/assets/more-info-selected.png?v=87697070631753780241792091782',
    '//rougholdglass.co.uk/cdn/shop/t/72/assets/dropdown-arrow.png?v=60682304572382095231792091782'
    ])
})

const app = function() {

  const selectList = [
    '.shape',
    '.orientation',
    '.frame-element'
  ]

  const defaultData = {
    'surcharge'   : 0,
    'name'        : 'none',
    'phone'       : 0000000000,
    'width'       : 1000,
    'height'      : 1000,
    'unit'        : 'mm',
    'columns'     : 2,
    'rows'        : 2,
    'shape'       : {price: 0, name: 'none'},
    'orientation' : {price: 0, name: 'none'},
    'mirror'      : {price: 0, name: 'none'},
    'finish'      : {price: 0, name: 'none'},
    'profile'     : {price: 0, name: 'none'},
    'layout'      : {price: 0, name: 'none'},
    'studs'       : {price: 0, name: "none"},
    'edgefinish'  : {price: 0, name: "none"},
    'bevel'       : {price: 0, name: "none"},
    'bevelsize'   : 5,
    'fixings'  : 'none',
    'quantity'    : 1
  }

  let total = 0;
  let frameData = {};

  start = function() {

    window.location !== window.parent.location ? $('.step').addClass('show') : false;
    inspira.lazyLoad();
    if(inspira.params.returning){
      getPrePopulateData().then(function(data){
        data = jQuery.parseJSON(data);
        // convert width and height back - move to own function at end.
        switch (data.unit ) {
          case 'mm':
            data.width = data.width * 1000; data.height = data.height * 1000;
            break;
          case 'cm':
            data.width = data.width * 100; data.height = data.height * 100;
            break;
          case 'inch':
            data.width = data.width * 39.3701; data.height = data.height * 39.3701;
            break;
          default:
        };
        data.width = Math.round(data.width)
        data.height = Math.round(data.height)
        $.each( data, function( key, val ) {
          selectValue(key,val);
        });
      }).fail(function(data){
      }).always(function(data){
        refreshUi(true);
        $('.shape , .orientation, .frame-element').click(function(){refreshUi(true)})
        $('.data').change(function(){refreshUi(true)})
        $('.select-styled li').click(function(){refreshUi(true)})
      })
    }else{
      refreshUi(true);
      $('.shape , .orientation, .frame-element').click(function(){refreshUi(true)})
      $('.data').change(function(){refreshUi(true)})
      $('.select-styled li').click(function(){refreshUi(true)})
    }


    $('#quantity.select-styled li').click(function(){sendToDatabase(frameData);})
    $('.total-submit .next, .mobile-header .next').click(function(){sendToDatabase(frameData)})
  }


  resetPrices = function() {
    selectList.forEach(function(input){
      $(input).each(function(){
        let value = $(this).find('.price-tag').data('price');
        $(this).find('.price-tag').data('new-price', value);
      })
    })
  }

  getAllInputs = function(){
    let data = {};
    $('input.data').each(function(){
      let value = $(this).val();
      let name = $(this).parents('.input-styled').eq(0).attr('id');
      if(!value.length){
        data[name] = null;
      } else {
        data[name] = value;
      }
    })
    return data;
  }

  getAllSelects = function(){
    let data = {};
    selectList.forEach(function(input){
      $(input + '.selected').each(function(){
        let value = $(this).find('.price-tag').data('price');
        let item = $(this).find('.title').html();
        let name = $(this).parents('.section').eq(0).attr('id');
        data[name] = {'price' : value, 'name' : item};
      })
    })
    return data;
  }

  getAllDropDowns = function() {
    let data = {};
    $('.select-styled').each(function(){
      let value = $(this).data('value');
      let name = $(this).attr('id');
      data[name] = value;
    })
    return data;
  }

  getAllCurrentValues = function(){
    let data = {};
    selectList.forEach(function(input){
      $(input + '.selected').each(function(){
        let value = typeof $(this).find('.price-tag').data('hidden-data')  !== 'undefined' ? $(this).find('.price-tag').data('hidden-data') : $(this).find('.price-tag').data('new-price');
        let item = $(this).find('.title').html();
        let name = $(this).parents('.section').eq(0).attr('id');
        data[name] = {'price' : value, 'name' : item};
      })
    })
    return data;
  }

  getUserInput = function() {
    const selects = getAllSelects()
    const inputs = getAllInputs()
    const dropDowns = getAllDropDowns();
    let userInput = $.extend(defaultData, selects, inputs, dropDowns);
    return userInput;
  }

  showPriceDifferences = function() {
    setColumnPrice = function($id){
      var currentPrice = 0;
      $id.each(function(){
        if($(this).hasClass('selected')){
          currentPrice = $(this).find('.price-tag').data('new-price');
        }
      })
      $id.each(function(){
        var price = $(this).find('.price-tag').data('new-price') - currentPrice;
        price = (price >= 0) ? '+£' + price.toFixed(2) : '-£' + -price.toFixed(2);
          $(this).find('.price-tag').text(price)
      })
    }

    setColumnPrice($('.shape'));
    setColumnPrice($('.orientation'));
    setColumnPrice($('#mirror-finish .frame-element'));
    setColumnPrice($('#finish .frame-element'));
    setColumnPrice($('#profile .frame-element'));
    setColumnPrice($('#layout .frame-element'));
    setColumnPrice($('#studs .frame-element'));
    setColumnPrice($('#edge .frame-element'));
  };

  updateCartTotal = function(){
    $('.frames-bespoke #content .header-frame .right .total-area').html('<p>Your Bespoke Frame</p>' + '<span>Total:</span> £' + total)
  }

  updateReview = function($data) {
    $('.review-content h2').html(frameData.mirror.name + ' ' + frameData.finish.name + ' Mirror');
    if(frameData.bevel.name == 'none'){var bevel = ''}else{bevel = frameData.bevel.name + 'mm'}
    var html =
    '<p><span>External Mirror Size:<span> ' + parseFloat(frameData.width * 1000).toFixed(0) + 'x' + parseFloat(frameData.height * 1000).toFixed(0) + 'mm</p>' +
    '<p><span>Hanging:<span> ' + frameData.orientation.name + ' & ' + frameData.shape.name + '</p>' +
    '<p><span>Layout:<span> ' + frameData.layout.name + ' - ' + buildColumns(frameData.columns, frameData.rows)  + '</p>' +
    '<p><span>Mirror Finish:<span> ' + frameData.mirror.name + '</p>' +
    '<p><span>Edges:<span> ' + frameData.edgefinish.name + ' ' + bevel + '</p>' +
    '<p><span>Frame Finish & Profile:<span> ' + frameData.finish.name + ' & ' + frameData.profile.name + '</p>' +
    '<p><span>Decorative Studs:<span> ' + frameData.studs.name + '</p>' +
    '<p><span>Fixings:<span> ' + frameData.fixings + '</p>';
    $('.product-info').html(html)

    $('.product-total .subtotal').html('<span>Subtotal:</span> £' + parseFloat(frameData.beforeDiscountPrice ).toFixed(2))
    $('.product-total .discount').html('<span>Trade Discount:</span> -£' + parseFloat(frameData.discount).toFixed(2))
    $('.product-total .total').html('<span>Total:</span> £' + parseFloat(frameData.price).toFixed(2))
  }

  buildColumns = function(columns, rows) {
    var columns = parseInt(columns);
    var rows = parseInt(rows);
    return columns + ((columns > 1) ? ' columns' : ' column') + ' and ' + rows + ((rows > 1)? ' rows' : ' row');
  }

  setTotal = function() {

    var discount = 0;
    frameData.userIsTrade = false;
    if(window.tag_orders_tag !== undefined){
      if(window.tag_orders_tag.length > 0){
        discount = Number(window.tag_orders_tag);
        frameData.userIsTrade = true;
      }
    }


    total = 0;
    total += parseFloat(frameData.surcharge ?frameData.surcharge : 0 );
    total += parseFloat(frameData.shape.price ? frameData.shape.price : 0);
    total += parseFloat(frameData.orientation.price ? frameData.orientation.price : 0);
    total += parseFloat(frameData.mirror.price ? frameData.mirror.price : 0);
    total += parseFloat(frameData.finish.price ? frameData.finish.price : 0);
    total += parseFloat(frameData.layout.price ? frameData.layout.price : 0);
    total += parseFloat(frameData.profile.price ? frameData.profile.price : 0);
    total += parseFloat(frameData.studs.price ? frameData.studs.price : 0);
    total += parseFloat(frameData.edgefinish.price ? frameData.edgefinish.price : 0);
    total += parseFloat(frameData.bevel.price ? frameData.bevel.price : 0);
    total += parseFloat(frameData.fixingspricing ? frameData.fixingspricing : 0);
    frameData.price = Math.round(total * 100) / 100;
    frameData.discount = Math.round(((total / 100) * discount)* 100) / 100;
    frameData.beforeDiscountPrice = Math.round((frameData.price) * 100) / 100;
    frameData.price = Math.round((frameData.price - frameData.discount) * 100) / 100;
    total = frameData.price * frameData.quantity;
    total = (Math.round(total * 100) / 100).toFixed(2);
    console.log(frameData.price, total)
  }

  refreshUi = function(repeat){
    frameData = getUserInput();
    email = {'email' : inspira.params.email === undefined ? 'None' : inspira.params.email  };
    fullName = {'name' : inspira.params.fullname === undefined ? 'None' : inspira.params.fullname};
    phone = {'phone' : inspira.params.phone === undefined ? 'None' : inspira.params.phone};
    resetPrices();
    if(repeat){
      sizeSection.refreshValues(frameData)
      mirrorSection.refreshValues(frameData)
      frameSection.refreshValues(frameData)
      profileSection.refreshValues(frameData)
      layoutSection.refreshValues(frameData)
      decorativeSection.refreshValues(frameData)
    }

    frameData = $.extend(frameData,email,fullName,phone,getAllCurrentValues());

    showPriceDifferences();
    setTotal();
    updateCartTotal();
    updateReview();

    console.log(frameData);
    let debugHtml = '';
    debugHtml += "<h3 style='margin-bottom:5px;'>Total: " + frameData.beforeDiscountPrice + "</h3>"
    debugHtml += "<h3 style='margin-bottom:5px;'>Trade Total: " + frameData.price + "</h3>"
    debugHtml += "<ul>"
    debugHtml += "<li>Surcharge: £" + frameData.surcharge + "</li>"
    debugHtml += "<li>Width: " + frameData.width + "m | Height " + frameData.height + "m</li>"
    debugHtml += "<li>Columns: " + frameData.columns + " | Rows " + frameData.rows + "</li>"
    debugHtml += "<li>Meters Squared: " + frameData.m2 + " <span>Width (" + frameData.width + ") * Height (" + frameData.height + ")</span></li>"
    debugHtml += "<li>Frame Linear Edge Length: " + frameData.linearEdgeLength + " <span>Width (" + frameData.width + " * 2) + Height (" + frameData.height + " *2 )</span> </li>"
    debugHtml += "<li>Glass Linear Edge Length " + frameData.framelinearEdgeLength + " <span>((Columns (" + frameData.columns + ") * 2) * Height (" + frameData.height + ") + ((Rows (" + frameData.rows + ") * 2) * Width (" + frameData.width + ")</span></li>"
    debugHtml += "<li>Shape: " + frameData.shape.name + " | Price " + frameData.shape.price + " <span>Static, Set In Admin</span></li>"
    debugHtml += "<li>Orientation: " + frameData.orientation.name + " | Price " +frameData.orientation.price + " <span>Static, Set In Admin</span></li>"
    debugHtml += "<li>Mirror Finish: " + frameData.mirror.name + " | Price " + frameData.mirror.price + "  <span>Base Price * Meters Squared (" + frameData.m2 + ")</span></li>"
    debugHtml += "<li>Frame Finish: " + frameData.finish.name + " | Price " + frameData.finish.price + " <span>Base Price * Frame Linear Edge Length (" + frameData.linearEdgeLength + ")</span></li>"
    debugHtml += "<li>Frame Profile: " + frameData.profile.name + " | Price " + frameData.profile.price + " <span>Base Price * Frame Linear Edge Length (" + frameData.linearEdgeLength + ")</span></li>"
    debugHtml += "<li>Layout: " + frameData.layout.name + " | Price " + frameData.layout.price + " <span>Static, Set By Product</span></li>"
    debugHtml += "<li>Studs: " + frameData.studs.name + " | Price " + frameData.studs.price + " <span>Base Price * Stud Quantity (" + frameData.studQuantiy + ")</span></li>"
    debugHtml += "<li>Stud Quantity " + frameData.studQuantiy + " <span>(Columns (" + frameData.columns + ")) - 1) * (Rows (" + frameData.rows + ") - 1)</span></li></li>"
    debugHtml += "<li>Edge Finish: " + frameData.edgefinish.name + " | Price " + frameData.edgefinish.price + " <span>Base Price * Glass Linear Edge Length (" + frameData.framelinearEdgeLength + ")</span></li>"
    debugHtml += "<li>Bevel: " + frameData.bevel.name + " | Price " + frameData.bevel.price + " <span>Base Price * Glass Linear Edge Length (" + frameData.framelinearEdgeLength + ")</span></li>"
    debugHtml += "<li>Fixings: " + frameData.fixings + " | Price " + frameData.fixingspricing + " <span>Static, Set In Admin</span></li>"
    debugHtml += "<li>Client Name: " + frameData.name + "</li>"
    debugHtml += "<li>Mobile " + frameData.phone + "</li>"
    debugHtml += "<li>Email " + frameData.email + "</li>"
    debugHtml += "<li>Is Trade Account? " + frameData.userIsTrade + "</li>"
    debugHtml += "</ul>"
    
    
    $('#debug').html(debugHtml)
  }

  sendToDatabase = function($data) {
    if(inspira.params.email === undefined){return false;}
    console.log($data);
    return $.ajax( "https://rougholdglass.appira.com/setSections?data=" + JSON.stringify($data));
  }


  getPrePopulateData = function() {
    return $.ajax( "https://rougholdglass.appira.com/getUserSelections?front=yes&email=" + inspira.params.returning);
  }
    // Takes in the id and value of any of the steps and selects it.
  selectValue = function(name,value) {

    $('#' + name).find('.frame-element').removeClass('selected')
    $('#' + name).find('.image').removeClass('frame-selected').removeClass('selected')
    $('#' + name).find('.frame-element, .shape, .orientation').each(function(){
      if($(this).find('.title').html().toLowerCase() == value.toLowerCase()){
        if($(this).hasClass('shape')){
          $(this)
          .addClass('selected shape-selected');
        }else if($(this).hasClass('orientation')){
          $(this)
          .addClass('selected orientation-selected');
        }else{
          $(this)
          .parent('.grid')
          $(this)
          .addClass('selected');
          $(this)
          .find('.image')
          .addClass('frame-selected selected');
        }
      }
    })

    $('#' + name + '.input-styled')
    .data('value',value)
    .find('.data').val(value);
    $('#' + name + '.select-styled')
    .addClass('select')
    .data('value',value)
    .find('.value').html(value)
  }
  start();
}

const steps = function(){

  var sections = {
    sizeSection: sizeSection,
    mirrorSection: mirrorSection,
    frameSection: frameSection,
    profileSection: profileSection,
    layoutSection: layoutSection,
    decorativeSection: decorativeSection
  };

  getSection = function(name){
    return sections[name];
  }

  getSectionErrors = function(currentStep){
    const currentErrors = currentStep.validate();
    return !currentErrors.length ? false : currentErrors;
  }

  $('.total-submit .next, .mobile-header .next').click(function(){
    inspira.scrollTop();
    let nextStep = $('.step').eq(($('.step:not(.hideStep)').parent().index() + 1))
    let currentSection = $('.step:not(.hideStep)').attr('name');
    let errors = getSectionErrors(getSection(currentSection));
    if(errors === 'customError'){return false}
    if(errors) {customiserUI.showErrors(errors); return false};


    if(currentSection === 'frameSection' & $('#frame-finish .frame-element.none').hasClass('selected')){
      nextStep = $('.step').eq(($('.step:not(.hideStep)').parent().index() + 2))
    }
    if(currentSection === 'frameSection' && nextStep.attr('name') === 'profileSection') {
      const options = $('#profile .frame-element');
      if(options && options.length > 0) { 
        const iterableOps = Array.from(options);
        for(const op of iterableOps) {
          const jOp = $(op);
          if(jOp.css('display') === 'none' && jOp.hasClass('selected')) {
            jOp.removeClass('selected');
            jOp.find('.image').removeClass('selected');
            jOp.find('.image').removeClass('frame-selected');
            $('#profile').removeData('value');
          }
        }
      }
    }
    const newUrl = window.location.href.replace(/customise(.*)\?/, `customise/${nextStep.attr('name')}?`)
    window.history.pushState({}, null, newUrl);
    customiserUI.changeStep(nextStep.attr('name'));
  })

}

const section = {

  dataitems : [],

  refreshValues : function(data){
    this.setDataAtts('.frame-element.selected','.title');
  },

  setDataAtts: function(elm,find){
    $(elm).each(function(){
      var data = JSON.stringify($(this).find(find).text().toLowerCase());
      $(this).parents('.section').eq(0).data('value',data);
    })
  },

  validate: function(){
    let errors = [];
    const layoutSelected = $('#layout .frame-element.selected .title').text();
    this.dataitems.forEach(function(ele){
      if(customiserUI.getInput(ele) === false ){

        if(ele.prop('id') === 'studs' && layoutSelected !== 'Panelled') {
          // Empty
        } else {
          errors.push(ele.prop('id'));
        }
      }
    })
    if(!errors.length) return false;
    return errors;
  }
}

const sizeSection = inspira.extend({

  dataitems: [$('#shape'),$('#orientation'),$('#width'),$('#height'),$('#unit')],

  validate: function(){
    let errors = [];
    if(customiserUI.getInput($('#width')) === false || customiserUI.getInput($('#width')) < 1 ){errors.push('width');};
    if(customiserUI.getInput($('#height')) === false || customiserUI.getInput($('#height')) < 1 ){errors.push('height');};

    var allowedHeight = 3000;
    var allowedWidth = 3000;

    switch ($('#unit .value').text()) {
      case 'mm':
      allowedHeight = 3000;
      allowedWidth = 3000;
        break;
      case 'cm':
      allowedHeight = 300;
      allowedWidth = 300;
        break;
      default:
        allowedHeight = 119;
        allowedWidth = 119;
        break;
    }

    if(customiserUI.getInput($('#width')) > allowedWidth){
      errors.push('width');
      customiserUI.showErrors(errors, 'This width is too large.');
      return 'customError';
    }

    if(customiserUI.getInput($('#height')) > allowedHeight){
      errors.push('height');
      customiserUI.showErrors(errors, 'This height is too large.');
      return 'customError';
    }


  

    if(errors.indexOf('height') !== -1 || errors.indexOf('width') !== 1){return errors};
    this.dataitems.forEach(function(ele){
      if(customiserUI.getInput(ele) === false ){
        errors.push(ele.prop('id'));
      }
    })
    if(!errors.length) return false;
    return errors;
  },

  refreshValues : function(data){
    switch (data.unit ) {
      case 'mm':
        data.width = data.width / 1000; data.height = data.height / 1000;
        break;
      case 'cm':
        data.width = data.width / 100; data.height = data.height / 100;
        break;
      case 'inch':
        data.width = data.width / 39.3701; data.height = data.height / 39.3701;
        break;
      default:
        console.log('error in unit');
    };

    // All the above does is turn whatever the user put in to meters.
    //data.width = Math.round(data.width* 100) / 100;
    //data.height = Math.round(data.height* 100) / 100;
    $('#height input').prop('disabled', false);
    $('#shape .shape').each(function(){
      var name = $(this).find('.title').html().toLowerCase();
      var price = $(this).find('.price-tag').data('price');
      var m2 = data.width * data.height;
      var linearEdgeLength = (data.width * 2) + (data.height*2);
      data.linearEdgeLength = linearEdgeLength;
      if($(this).hasClass('selected')){
        data.m2 = m2;

        // Show All Options Again
        if(name == 'rectangular'){
          $('#orientation').fadeIn();
          $('.orientation.both').fadeIn();
          $('.orientation.portrait').fadeIn();
        }
        if(name == 'arched top'){
          $('#orientation').fadeIn();
          $('.orientation.both').hide().removeClass('selected orientation-selected');
          $('.orientation.portrait').fadeIn();
        }

        // Reset Ability to do both charge //
        if($('.orientation.both .price-tag').data('price-clone') > 0){
          $('.orientation.both .price-tag').data('price',$('.orientation.both .price-tag').data('price-clone')) 
          $('.orientation.both .price-tag').data('price-clone', $('.orientation.both .price-tag').data('price'));
        }

        // Show and Hide Based On Logic
        if(name == 'square'){
          $('#height input').prop('disabled', true);
          if($('#height input').val().length > 0){
            $('#height input').addClass('has-content');
          }else{
            $('#height input').removeClass('has-content')
          }
          $('#orientation').hide();
          $('.orientation').removeClass('selected orientation-selected')
          $('.orientation.portrait').addClass('selected orientation-selected')
          if($('#height').data('value') != $('#width').data('value')){
            var val = $('#width').data('value');
            $('#height').data('value', val);
            $('#height').find('input').val(val);
            //refreshUi(false);
          }
          // If Sqaure, no ability to do both charge //
          $('.orientation.both .price-tag').data('price-clone',$('.orientation.both .price-tag').data('price')) 
          $('.orientation.both .price-tag').data('price',0)
          
          //refreshUi(false);
          

        }else if(name == 'circular or oval'){
          $('#orientation').hide();
          $('.orientation').removeClass('selected orientation-selected')
          $('.orientation.portrait').addClass('selected orientation-selected')
        }else if(name == 'arched top'){ 
          $('.orientation.both').hide().removeClass('selected orientation-selected');
          $('#orientation').fadeIn();
        }
      }
      data.linearEdgeLength = linearEdgeLength;
      data.m2 = m2;
      if(name == 'arched top' || name == 'circular or oval'){
        //$(this).find('.price-tag').data('new-price' , newPrice);
      }
    })

    data.width > window.inspira.surcharge_width ||  data.height > window.inspira.surcharge_height ? data.surcharge = window.inspira.surcharge : data.surcharge = 0;

    // If Square selected no surcharge //
    if($('.shape.square').hasClass('selected')){
      data.surcharge = 0;
    }
    this.setDataAtts('.shape.selected, .orientation.selected','.title');
  }
}, section)

const mirrorSection = inspira.extend({
  dataitems: [$('#mirror')],
  refreshValues : function(data){
    $('#mirror .frame-element').each(function(){
      var price = $(this).find('.price-tag').data('price');
      const hiddenPrice = (price * data.m2).toFixed(2);
      $(this).find('.price-tag').data('hidden-data', hiddenPrice);
      $(this).find('.price-tag').data('new-price' , price);
    });
    this.setDataAtts('.frame-element.selected','.title');
  },

}, section)

const frameSection = inspira.extend({
  dataitems: [$('#finish')],

  refreshValues : function(data){
    $('#finish .frame-element').each(function(){
      var price = $(this).find('.price-tag').data('price');
      const hiddenPrice = (price * data.linearEdgeLength).toFixed(2);
      $(this).find('.price-tag').data('hidden-data', hiddenPrice);
      $(this).find('.price-tag').data('new-price' , price);
    })
    if($('#finish .frame-element.selected .title').text() == 'Frameless'){
      $('#profile .frame-element').removeClass('selected');
      $('#profile .frame-element .image').removeClass('selected frame-selected');
      $('#profile .frame-element.none').addClass('selected');
      $('#profile .frame-element.none .image').addClass('selected frame-selected');
    }
    var baseImage = $('#finish .frame-element.selected .image').data('bksrc');
    if(baseImage !== undefined){
      var canvas = document.getElementById('productImage')
      var ctx = canvas.getContext('2d');
      var image = new Image;
      image.onload = function () {
        ctx.imageSmoothingEnabled = false;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(image, 0, 0, 200, 200);
      };
      image.setAttribute('crossOrigin','Anonymous');
      image.src = baseImage;
      data.image = baseImage;
    }
    this.setDataAtts('.frame-element.selected','.title');
  },

}, section)

const profileSection = inspira.extend({
  dataitems: [$('#profile')],

  refreshValues : function(data){
    var finish = data.finish.name.toLowerCase();
    console.log(finish, 'selected')
    var i = 'even';
    $('#profile .frame-element').each(function(){
      $(this).hide().removeClass('shown');
      console.log($(this).data('finish'))
      const itemFinish = $(this).data('finish');
      if(finish.indexOf(itemFinish) > -1 && itemFinish ){i = i == 'even' ? 'odd' : 'even';$(this).show().addClass(i);}
      var price = $(this).find('.price-tag').data('price');
      const hiddenPrice = (price * data.linearEdgeLength).toFixed(2);
      $(this).find('.price-tag').data('hidden-data', hiddenPrice);
      $(this).find('.price-tag').data('new-price' , price);
    })
    this.setDataAtts('.frame-element.selected','.title');
  },
}, section)

const layoutSection  = inspira.extend({
  dataitems: [$('#layout'),$('#columns'),$('#rows')],

  validate: function(){
    let errors = [];
    if(customiserUI.getInput($('#columns')) === false || customiserUI.getInput($('#columns')) < 1 ){errors.push('columns');};
    if(customiserUI.getInput($('#rows')) === false || customiserUI.getInput($('#rows')) < 1 ){errors.push('rows');};
    if(errors.indexOf('rows') !== -1 || errors.indexOf('columns') !== -1){return errors};
    this.dataitems.forEach(function(ele){
      if(customiserUI.getInput(ele) === false ){
        errors.push(ele.prop('id'));
      }
    })
    if(!errors.length) return false;
    return errors;
  },


  refreshValues : function(data){
    if(data.layout.name.toLowerCase() == 'single panel' || data.layout.name.toLowerCase() == 'mondrian geometric design'){
      $('.col-rows-calc').hide();
      $('#studs').hide();
      $('#studs .frame-element').removeClass('selected');
      $('#studs .frame-element .image').removeClass('selected frame-selected');
      $('#studs .frame-element.none').addClass('selected');
      $('#studs .frame-element.none .image').addClass('selected frame-selected');
      if($('#columns').data('value') !== 1 && $('#rows').data('value') !== 1){
        $('#columns').data('value', 1);
        $('#rows').data('value', 1); $('#columns').find('input').val(1);
        $('#rows').find('input').val(1);
        refreshUi(true);
      }
    }
    else if(data.layout.name.toLowerCase().indexOf('bordered') > -1){
      $('#columns').data('value', 3);
      $('#rows').data('value', 3);
      $('#columns').find('input').val(3);
      $('#rows').find('input').val(3);
      $('.col-rows-calc').hide();
      $('#studs').hide();
      $('#studs .frame-element').removeClass('selected');
      $('#studs .frame-element .image').removeClass('selected frame-selected');
      $('#studs .frame-element.none').addClass('selected');
      $('#studs .frame-element.none .image').addClass('selected frame-selected');
    }
    else{
      $('.col-rows-calc').show();
      $('#studs').show();
      if($('#columns').data('value') === 1 && $('#rows').data('value') === 1){
        $('#columns').data('value', 2);
        $('#rows').data('value', 2);
        $('#columns').find('input').val(2);
        $('#rows').find('input').val(2);
        refreshUi(true);
      }
    }
    if (data.layout.name.toLowerCase() == 'mondrian geometric design'){
      $('.col-rows-norm').show();
    }else{
      $('.col-rows-norm').hide();
    }



    this.setDataAtts('.frame-element.selected','.title');
  }

}, section)

const decorativeSection = inspira.extend({
  dataitems: [$('#studs'),$('#edgefinish'), $('#bevelsize'),$('#fixings')],

  refreshValues : function(data){

    data.framelinearEdgeLength = ((data.columns * 2) * data.height) + ((data.rows * 2) * data.width);
    data.studQuantiy = (data.columns - 1) * (data.rows - 1);



    $('#studs .frame-element').each(function(){
      var price = $(this).find('.price-tag').data('price');

      const hiddenPrice = (price * data.studQuantiy).toFixed(2);

      $(this).find('.price-tag').data('hidden-data', hiddenPrice);
      $(this).find('.price-tag').data('new-price' , price);
    })

    $('#edgefinish .frame-element').each(function(){
      var price = $(this).find('.price-tag').data('price');

      const hiddenPrice = (price * data.framelinearEdgeLength).toFixed(2);

      $(this).find('.price-tag').data('hidden-data', hiddenPrice);
      $(this).find('.price-tag').data('new-price' , price);
    })
    if (data.edgefinish.name.toLowerCase().indexOf('bevelled') !== -1 ){
      $('#bevelsize-wrap').show();
      $('#bevelsize').data('value') == 'none' ? $('#bevelsize').data('value', 5) : '';
    }else{
      $('#bevelsize-wrap').hide();
      $('#bevelsize').data('value', 'none');
    }


    var val = typeof($('#bevelsize').data('value')) == "undefined" ? '' : $('#bevelsize').data('value');
    var price;
    if(val === '' || val === 'none'){
      price = 0;
    }else if (val < 30){
      price = $('#bevel-low').data('value');
    } else if (val < 50) {
      price = $('#bevel-mid').data('value');
    } else {
      price = $('#bevel-high').data('value');
    }
    data.bevel = {name: val, price: (price * data.framelinearEdgeLength).toFixed(2)}



    if ($('#fixings .value').text() == 'Yes'){
      data.fixingspricing = parseFloat($('#fixings').data('price'))
    }else{
      data.fixingspricing = 0;
    }


    this.setDataAtts('.frame-element.selected','.title');
  },


}, section)




$(function(){
  if($('.frames-bespoke').length > 0){
    app();
    steps();
  }
})




